/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_107Inputs */

const cs_ares_legal_form_107 = /** @type {(inputs: Ares_Legal_Form_107Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fyzická osoba — svobodné povolání`)
};

const en_ares_legal_form_107 = /** @type {(inputs: Ares_Legal_Form_107Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natural person — liberal profession`)
};

/**
* | output |
* | --- |
* | "Natural person — liberal profession" |
*
* @param {Ares_Legal_Form_107Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_107 = /** @type {((inputs?: Ares_Legal_Form_107Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_107Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_107(inputs)
	return cs_ares_legal_form_107(inputs)
});